import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { ProductionCenterFilters } from '../types';

export const useProductionCenterFilters = createTableFiltersState<ProductionCenterFilters>({
  tableKey: TableKeyEnum.PRODUCTION_CENTER,
});
